import { Asterisk } from "lucide-react";
import { useLang } from "./i18n";

export function Marquee() {
  const { t } = useLang();
  const row = [...t.marquee, ...t.marquee];
  return (
    <div data-testid="editorial-marquee" className="marquee-wrap overflow-hidden border-b border-navy/10 bg-paper py-7">
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-display text-2xl italic text-navy/75 md:text-3xl">
                  {item}
                </span>
                <Asterisk size={22} className="shrink-0 text-maple" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
